var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":_vm.widgetConfig.span || 24}},[_c('div',{style:(_vm.getTextStyle)},[_vm._v(_vm._s(_vm.widgetConfig.showName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }